<form [formGroup]="otherLocationForm">
<scu-title-header>{{ 'other-location.description'  | translate }}</scu-title-header>

  <label class="text-16 lh-15 mb-5"> {{ 'other-location.searchDescription' | translate }} </label>
  <input scu-google-autocomplete formControlName="location" class="w-100 form-control scu-secondary-faded-border icon-scu-secondary mb-0" [options]="options" (ngModelChange)="setTimezone()">


</form>
